import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  to { transform: rotate(360deg); }
`;

const sizeMap = {
  sm: '28px',
  md: '44px',
  lg: '64px',
};

const borderMap = {
  sm: '3px',
  md: '4px',
  lg: '5px',
};

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem 1rem;
  min-height: 200px;
  width: 100%;
`;

export const Spinner = styled.div<SpinnerProps>`
  width: ${({ size = 'md' }) => sizeMap[size]};
  height: ${({ size = 'md' }) => sizeMap[size]};
  border-radius: 50%;
  border: ${({ size = 'md' }) => borderMap[size]} solid
    ${({ theme }) => theme.colors.primaryMuted};
  border-top-color: ${({ theme }) => theme.colors.primary};
  animation: ${rotate} 0.75s linear infinite;
  flex-shrink: 0;
`;

export const LoadingText = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textMuted};
  letter-spacing: 0.2px;
`;
